<template>
  <Modal
    class="modal-validate"
    :name="modalName"
    :show-close="false"
    :cover-closeable="false"
    :close-btn-handler="handleClose"
    @modalClose="handleClose"
  >
    <div class="content auto_scale" slot="modal-content">
      <div class="close-right" @click="handleClose"></div>
      <div class="title_text" v-html="mainData.award_popup_title || '领取优惠'"></div>
      <div class="input_content-wrap">
        <div class="line_wrap">
          <input
            v-model="telNum"
            type="tel"
            class="tel input"
            placeholder="请输入手机号"
            :maxlength="11"
            id="inputPhone"
            @focus="setViewArea('phone')"
            @blur="temporaryRepair"
          />
        </div>
        <div class="line_wrap vali_wrap">
          <input
            v-model="validNum"
            type="number"
            placeholder="手机验证码"
            class="vali_num input"
            id="inputCode"
            @focus="setViewArea('code')"
            @input="handleInputLength"
            @blur="temporaryRepair"
          />
          <div
            class="vali_btn"
            :class="{ disable: !telStatus || !validBtnStatus }"
            @click="getValidNum"
          >{{ validBtnText }}<span v-if="validBtnText !=='获取验证码'">s</span></div>
        </div>
      </div>
      <div
        class="confirm_btn"
        :class="{ disable: !validStatus || !this.telStatus }"
        @click="handleGetVoucher"
        v-html="mainData.award_popup_button_desc || '点击领取'"
      ></div>
    </div>
  </Modal>
</template>
<script>
/* eslint-disable no-undef */
import { util, log } from '@ali/amap-lib';
import service from '../../js/service';
import MsgBox from '../../js/msgbox';
// import toast from '../../js/toast';
// import aosErrorHandle from '../../js/aos-error-handler';

// import CONFIG_AOS from '../../../config/config.aos';

import Modal from '../Modal.vue';
import {platFormData, dataType, accountList, accountName} from "../../../config/config.account" // 数据上报引入
/**
 * mixin
 */
export default {
  data() {
    return {
      modalName: 'modalValidateShow',
      showValidModel: false,
      telNum: '',
      validNum: '',
      validBtnStatus: true,
      validNumLength: 6,
      validBtnText: '获取验证码',
      validTimer: null,
      gdFrom: null,
      stepCode: false, // 直接领取不需要手机号和验证码
      clickTime: null, // 防连点参数
      commonType: '',
      focusFlag: false
    };
  },
  components: {
    Modal,
  },
  props: {
    mainData: {
      required: true,
      type: Object,
      default() {
        return {};
      },
    },
    location: {
      type: Object,
      default() {
        return {};
      },
    },
    jumpAction: {
      default: ''
    }
  },
  created() {
    this.gdFrom = util.getUrlParam('gd_from');
    log.log('award_pv', {
      source: this.gdFrom,
      type: service.browserEnvironment(),
      url: window.location.href,
      text: navigator.userAgent
    });
  },
  computed: {
    telStatus() {
      return /^(1[3-9])\d{9}$/.test(this.telNum.trim());
    },
    validStatus() {
      return (
        this.validNum.trim()
        && this.validNum.trim().length === this.validNumLength
      );
    }
  },
  methods: {
    // 获取验证码请求方法
    async handleVerify(params) {
      const data = await service.verify(params).catch((e) => {
        console.log(e);
        const code = +e.code;
        if (code === 1001) {
          MsgBox({
            content: '您点的太快了，请稍后尝试',
            btns: [
              // msgbox按钮列表，可以多个按钮
              {
                text: '关闭', // 按钮文案
                fun: () => {}, // 点击按钮触发的方法
                noClose: false // 是否不需要关闭弹窗，默认（false）需要关闭
              }
            ]
          });
          setTimeout(() => {
            this.validBtnStatus = true;
          }, 1000);
        }
      });
      if (!data) {
        return false;
      }
      this.validBtnText = 60;
      this.validTimer = setInterval(() => {
        if (this.validBtnText === 0) {
          this.validTimer = clearInterval(this.validTimer);
          this.validBtnStatus = true;
          this.validBtnText = '获取验证码';
          return;
        }
        this.validBtnText--;
      }, 1000);
    },
    // 获取验证码
    getValidNum() {
      const that = this;
      if (this.telStatus && this.validBtnStatus) {
        log.log('validatePop', {
          source: this.gdFrom,
          type: service.browserEnvironment(),
          url: window.location.href,
          text: navigator.userAgent
        });
        this.validBtnStatus = false;
        if (umidToken.indexOf('defaultToken') !== -1) {
          if (!umM) {
            // 强制刷新页面
            that.$parent.refresh(); // 调用父组件refresh方法
          } else {
            // 从新初始化umidtoken
            that.$parent.getUmid()
              .then((t) => {
                console.log(t, '>>>>>>>>>>>>>>>>>');
                const params = [
                  { mobile: this.telNum, sign: 1 },
                  { umid_token: t, sign: 1 },
                  {
                    ts: new Date()
                      .getTime()
                      .toString()
                      .substr(0, 10),
                    sign: 1
                  }
                ];
                console.log('获取验证码请求参数1', params);
                this.handleVerify(params);
              })
              .catch((e) => {
                console.log(e);
                // 强制刷新
                that.$parent.refresh(); // 调用父组件refresh方法
              });
          }
        } else {
          const params = [
            { mobile: this.telNum, sign: 1 },
            { umid_token: umidToken, sign: 1 },
            {
              ts: new Date()
                .getTime()
                .toString()
                .substr(0, 10),
              sign: 1
            }
          ];

          console.log('获取验证码请求参数2', params);
          this.handleVerify(params);
        }
      }
    },
    // 处理领券
    async handleGetVoucher() {
      log.log('award_btn', {
        source: this.gdFrom,
        type: service.browserEnvironment(),
        url: window.location.href,
        text: navigator.userAgent
      });
      if (this.clickTime && new Date().getTime() - this.clickTime < 1000) {
        return;
      }
      this.clickTime = new Date().getTime();
      if ((this.telStatus && this.validStatus) || this.stepCode) {
        // amapApp.log.log('getcoupon', { source: this.gdFrom, url: window.location.href });
        // 参数
        const urlParams = util.getUrlParam();
        const plat_form = urlParams.plat_form;
        const params = [
          { source: urlParams.gd_from, sign: 1 },
          { mobile: this.telNum, sign: 1 },
          { ts: new Date().getTime().toString().substr(0, 10), sign: 1 },
          { verify_code: this.validNum },
          { mini_app: urlParams.mini_app || 0 },
          // { subsource: urlParams.subsource || '' },
          { rootUrl: location.href || '' },
          { subsource: plat_form || urlParams.subsource || '' }, // 2021-7-14 作为数据上报参数
          // 司拉乘新增 driver_sharecode 和 share_type
          { driver_sharecode: urlParams.sharecode || urlParams.driver_sharecode || '' },
          { share_type: urlParams.sharetype || urlParams.share_type || '' }
        ];
        // if (plat_form && platFormData.includes(plat_form)) {
        //   // to do
        //   const ad_channel = dataType[plat_form]['ad_channel']
        //   if (ad_channel) {
        //     params.push({ad_channel})
        //   }
        //   if (ad_channel === 1 && dataType[plat_form]['action'] && (urlParams.qz_gdt || urlParams.gdt_vid || urlParams.click_ext)) {
        //     params.push({"ad_data":JSON.stringify({"url": location.host, "qz_gdt": urlParams.qz_gdt ? urlParams.qz_gdt : urlParams.gdt_vid ? urlParams.gdt_vid : "", "click_ext": urlParams.click_ext ? urlParams.click_ext : ""})})
        //   } else if (ad_channel === 3 && dataType[plat_form]['action'] && urlParams.clickid) {
        //     params.push({"ad_data": JSON.stringify({"url": encodeURIComponent(location.href), "click_id": urlParams.clickid})})
        //   } else if (ad_channel === 4 && dataType[plat_form]['action'] && urlParams.callback) {
        //     params.push({"ad_data": JSON.stringify({"callback": urlParams.callback})})
        //   }
        // }
        const accountIndex = accountName.indexOf(plat_form && plat_form.substr(0, 2));
        if (plat_form && accountIndex !== -1) {
          const ad_channel = accountList[accountIndex]['ad_channel'] | 0;
          if (ad_channel) {
            params.push({ad_channel})
          }
          if (ad_channel === 1 && (urlParams.qz_gdt || urlParams.gdt_vid || urlParams.click_ext)) {
            params.push({"ad_data":JSON.stringify({"url": location.host, "qz_gdt": urlParams.qz_gdt ? urlParams.qz_gdt : urlParams.gdt_vid ? urlParams.gdt_vid : "", "click_ext": urlParams.click_ext ? urlParams.click_ext : ""})})
          } else if (ad_channel === 3 && urlParams.clickid) {
            params.push({"ad_data": JSON.stringify({"url": encodeURIComponent(location.href), "click_id": urlParams.clickid})})
          } else if (ad_channel === 4 && urlParams.callback) {
            params.push({"ad_data": JSON.stringify({"callback": urlParams.callback})})
          }
        }
        this.$parent.rewardData(params, false);// 请求首页的奖励弹窗
        setTimeout(() => { this.handleClose(); }, 0);
      }
    },
    // 处理关闭
    handleClose() {
      console.log(this.validTimer);
      if (this.validTimer) this.validTimer = clearInterval(this.validTimer);
      this.telNum = '';
      this.validNum = '';
      this.validBtnText = '获取验证码';
      this.validBtnStatus = true;
      this.showValidModel = false;
      this.$emit('modalHandler', 'modalClose', this.modalName);
    },
    // 处理4数限制
    handleInputLength() {
      if (this.validNum.length >= this.validNumLength) {
        this.validNum = this.validNum.slice(0, this.validNumLength);
      }
    },
    // 打开验证弹窗
    openValidModel() {
      this.showValidModel = true;
    },
    // fixed: 输入框获取焦点时键盘压盖弹窗
    setViewArea(type) {
      setTimeout(() => {
        const len = type === 'phone' ? 100 : 150;
        this.focusFlag = true;
        window.scrollTo(0, len);
      }, 0);
    },
    // 解决ios12键盘收起页面不能下来的问题
    temporaryRepair() {
      this.focusFlag = false;
      this.$nextTick(() => {
        setTimeout(() => {
          if (!this.focusFlag) {
            window.scrollTo(0, 0); // 页面向下滚动
          }
        }, 200);
      });
      // this.$nextTick(() => {
      //   window.scrollTo(0, 0); // 页面向下滚动
      // });
    },
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../css/common-mixin";
.modal-validate {
  .modal {
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: rpx(24px);
    width: rpx(578);
    height: rpx(680);
  }
  .content {
    position: relative;
    width: rpx(578);
    height: rpx(680);
    border-radius: rpx(16);
    background-color: #fff;
    .close-right {
      position: absolute;
      top: 0;
      right: 0;
      width: rpx(90);
      height: rpx(90);
      background: url("../../../assets/modal/close-gray.png") center no-repeat;
      background-size: rpx(31) rpx(31);
    }
    .title_text {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      color: #000000;
      text-align: center;
      font-size: rpx(43);
      margin-top: rpx(73);
      margin-bottom: rpx(54);
    }
    .input_content-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: rpx(480);
      height: rpx(208);
      margin: 0 auto;
      margin-bottom: rpx(122);
      .line_wrap {
        width: 100%;
        height: rpx(84);
        border: 1px solid #e1e1e1;
        border-radius: rpx(15);
        .tel {
          width: 100%;
          height: 100%;
          padding-left: rpx(20);
        }
        .input {
          font-size: rpx(28);
          border: 1px solid transparent;
          border-left-color: transparent;
          outline: none;
          border-radius: 0.16rem;
        }
      }
      .vali_wrap {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .vali_num {
          width: rpx(340);
          height: 100%;
          padding-left: rpx(20);
        }
        .vali_btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: rpx(180);
          height: 100%;
          color: #fff;
          background: #3377ff;
          border-top-right-radius: rpx(15);
          border-bottom-right-radius: rpx(15);
        }
        .disable {
          background: #ccc;
        }
      }
    }
    .confirm_btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: rpx(480);
      height: rpx(80);
      margin: 0 auto;
      background-color: #547eff;
      color: #fff;
      font-size: rpx(36);
      font-weight: 600;
      border-radius: rpx(16);
    }
    .disable {
      background-color: #cccccc;
    }
  }
}

</style>
